import { FieldProps, getIn } from 'formik';
import { isEmpty } from '../../utils/getValidator';
import InputWithIconAndButton, { InputWithIconAndButtonProps } from '../atoms/InputWithIconAndButton';
import ErrorMessage from '../atoms/ErrorMessage';

const InputWithIconAndButtonField = ({
  field,
  form: { touched, errors },
  ...rest
}: FieldProps & InputWithIconAndButtonProps) => {
  const isTouched = getIn(touched, field.name);
  const error = isTouched && getIn(errors, field.name);
  const hasSuccess =
    isTouched && !error && !isEmpty(typeof field.value === 'string' ? field.value.trim() : field.value);

  return (
    <div className="input-with-icon-and-button">
      <InputWithIconAndButton hasError={!!error} hasSuccess={hasSuccess} {...field} {...rest} />
      <ErrorMessage label={rest.placeholder!} error={error} />
    </div>
  );
};

export default InputWithIconAndButtonField;
